import { render, staticRenderFns } from "./ItemsMasterCreate.vue?vue&type=template&id=c44beb4c&scoped=true&"
import script from "./ItemsMasterCreate.vue?vue&type=script&lang=js&"
export * from "./ItemsMasterCreate.vue?vue&type=script&lang=js&"
import style0 from "./ItemsMasterCreate.vue?vue&type=style&index=0&id=c44beb4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44beb4c",
  null
  
)

export default component.exports